import React from 'react';
import { useNavigate } from 'react-router-dom';

import Typography from '../../components/Typography';
import Button from '../../components/Button';
import Container from '../../components/Container';
import Image from '../../components/Image';

import error404 from '../../assets/images/404.png';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container className="mt-[7.563rem] max-[1023px]:mt-12">
      <div className="mx-auto grid items-center justify-center gap-4 grid-cols-[18.5%_48%] max-[1023px]:grid-cols-1 min-[1024px]:max-[1439px]:grid-cols-[25.5%_67%]">
        <div className="grid gap-y-6 mb-[7.438rem] max-[1023px]:text-center max-[1023px]:mb-[4.125rem] max-[1023px]:justify-items-center">
          <Typography as="h1" variant="display1" className="text-neutral-darkest">
            Parece que essa página sumiu!
          </Typography>
          <div className="w-[85%] max-[1023px]:w-full">
            <Typography as="p" variant="body2" className="text-neutral-darkest">
              Bora tentar de novo? Deixa que eu te ajudo a chegar onde precisa.
            </Typography>
          </div>
          <Button
            text="Voltar pra página inicial"
            type="button"
            variant="primary"
            id="mp__not-found_back-initial-btn"
            classNames="py-3 px-[16.5px]"
            onClick={() => navigate('/')}
          />
          <Button
            text="Voltar pra página anterior"
            type="button"
            variant="secondary"
            id="mp__not-found_back-previous-btn"
            classNames="py-3 px-[9px]"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="grid justify-center">
          <Image images={[{ img: `${error404}`, alt: 'Ilustração de erro 404' }]} />
        </div>
      </div>
    </Container>
  );
};

export default PageNotFound;
